import { render, staticRenderFns } from "./AppointmentTypeItemSettings.vue?vue&type=template&id=7f257f9d&scoped=true&"
import script from "./AppointmentTypeItemSettings.vue?vue&type=script&lang=ts&"
export * from "./AppointmentTypeItemSettings.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentTypeItemSettings.vue?vue&type=style&index=0&id=7f257f9d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f257f9d",
  null
  
)

export default component.exports